import React from 'react';

import { Col, Row } from 'components/bootstrap';

import SharedCollectionsList from './SharedCollectionsList/SharedCollectionsList';

type Props = {
  teamId: string;
};

const TeamCollections = ({ teamId }: Props) => (
  <Row>
    <Col md={12}>
      <SharedCollectionsList id={teamId} filterBy="team" />
    </Col>
  </Row>
);
export default TeamCollections;
